import { useEffect, useState } from "react";
import MultiSelectBox from "../FormComponents/MultiSelectBox";
import { mapArrayToObject } from "../../commonFunctions/arrayFunc";
import axiosInstance, { handleApiError } from "../../services/axiosService";

const AccessTemplateSelection = ({ templates, handleChange, className = "" }) => {
  const [allTemplates, setAllTemplates] = useState([]);
  const [selectedTemplatesData, setSelectedTemplatesData] = useState([]);

  const handleTemplate = (groups) => {
    //   const templateIDs = groups.map((group) => group.id);
    //   handleChange(templateIDs);
    setSelectedTemplatesData(groups);

    handleChange(groups.map((temp) => temp.id));
  };

  // const saveAccessTemplate = () => {
  //   handleChange(selectedTemplatesData.map((temp) => temp.id));
  // };

  useEffect(() => {
    const fetchAllTemplates = async () => {
      try {
        const { data } = await axiosInstance.get(`/access-templates`);
        const { result: templateObject } = mapArrayToObject(data);

        let currectTemplate = templates || [];
        currectTemplate = currectTemplate.filter((id) => templateObject[id]).map((id) => templateObject[id]);

        setAllTemplates(data);
        setSelectedTemplatesData(currectTemplate);
      } catch (error) {
        handleApiError(error);
      }
    };
    fetchAllTemplates();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`flex_column space_between ${className}`}>
      <div className="builder_form ">
        <MultiSelectBox
          options={allTemplates || []}
          selectedData={selectedTemplatesData}
          label="Select Access Templates"
          onChange={handleTemplate}
        />
      </div>
    </div>
  );
};

export default AccessTemplateSelection;
